import { init } from '@atlaskit/react-ufo/interaction-metrics-init';
import type { Config } from '@atlaskit/react-ufo/config';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import { analyticsClient } from '../analyticsClient';
import { assetsConfig } from './assets-config';

export function initUFO(): void {
	const config: Config = {
		product: 'rovoExtension',
		region: process.env.NODE_ENV === 'production' ? 'prod-west2' : 'stg-east',

		kind: {
			page_load: 1,
			transition: 1,
			press: 1,
			typing: 0,
			legacy: 0,
			hover: 0,
		},

		vc: {
			enabled: true,
			heatmapSize: 200,
			oldDomUpdates: false,
			devToolsEnabled: process.env.NODE_ENV !== 'production',
			selectorConfig: {
				id: false,
				role: true,
				className: true,
				testId: true,
			},
		},
		assetsConfig,
	};

	init(Promise.resolve(analyticsClient), config);

	traceUFOPageLoad();
}
